
import styled from 'styled-components'

import MEDIA from 'constants/media'
import FONTS from 'constants/fonts'


export const Wrap = styled.div`
  margin: 40px auto;
  max-width: 900px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  ${MEDIA.medium`
    margin: 40px auto 0 auto;
  `}
`

export const GroupItem = styled.div`
  margin: 20px auto;
  text-align: center;
  h3 {
    margin: 20px 0 25px;
  }
`

export const Phone = styled.div`
  font-size: ${FONTS.PARAGRAPHXLARGE};
  font-weight: ${FONTS.WEIGHTLIGHT};
`
